<template lang="pug">

  div

    .settingsDivider(v-if="divide")

    .settingsSubtitle.settingsSubtitle--clearTop
      span.inlineMiddle.mr-1 {{ title }}

      v-tooltip(top color="rgba(0, 0, 139, 0.95)" v-if="informations.length > 0")
        template(v-slot:activator="{ on, attrs }")
          i(v-bind="attrs" v-on="on" aria-hidden="true" class="mdi mdi-help-circle").mdi.settingsSectionIcon
        span
          template(v-for="(information, informationIndex) in informations")
            .infoTitle(v-html="information.title" :class="{ 'mt-4': informationIndex !== 0 }")
            .infoMessage(v-html="information.message")

</template>

<script>

  export default {
    name: 'SettingsSection',

    props: {
      title: { type: String, required: true },
      divide: { type: Boolean, default: () => true },
      informations: { type: Array, default: () => [] },
    },

    /* methods: {
      click () {
        this.$emit('click')
      },
    }, */
  }

</script>
